// extracted by mini-css-extract-plugin
module.exports = {"errorImage":"errorPage_errorImage__2n_a8","backButton":"errorPage_backButton__3kpfd"};